// src/services/api.js
import axios from 'axios';

const normalizeUrl = (value) => String(value || '').trim().replace(/\/+$/, '');

export const resolveApiBaseUrl = () => {
  const rawBaseURL = process.env.REACT_APP_API_URL || 'https://api.mpzdt.my.id/api/';
  return normalizeUrl(rawBaseURL).replace(/^http:\/\//i, 'https://');
};

export const buildFileUrl = (filePath) => {
  const rawPath = String(filePath || '').trim();
  if (!rawPath) return '';
  if (/^https?:\/\//i.test(rawPath)) return rawPath;

  const normalizedPath = rawPath.replace(/^\/+/, '');
  const apiBaseUrl = normalizeUrl(resolveApiBaseUrl());
  const baseUrl = /^(uploads?|storage)\//i.test(normalizedPath)
    ? apiBaseUrl.replace(/\/api$/i, '')
    : apiBaseUrl;
  if (!baseUrl) return `/${rawPath.replace(/^\/+/, '')}`;

  return `${baseUrl}/${normalizedPath}`;
};

const normalizedBaseURL = resolveApiBaseUrl();

const api = axios.create({
  baseURL: normalizedBaseURL,
  timeout: 300000, // Tambah timeout untuk upload file besar
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add request interceptor untuk debugging
api.interceptors.request.use(
  (config) => {
    const baseURL = String(config.baseURL || '').replace(/\/+$/, '');
    const requestUrl = String(config.url || '');

    if (baseURL.endsWith('/api') && requestUrl.startsWith('/api/')) {
      config.url = requestUrl.replace(/^\/api/, '');
    }

    console.log('Request:', {
      baseURL: config.baseURL,
      url: config.url,
      method: config.method,
      data: config.data
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor untuk debugging
api.interceptors.response.use(
  (response) => {
    console.log('Response:', response);
    return response;
  },
  (error) => {
    console.error('API Error:', {
      baseURL: error.config?.baseURL,
      url: error.config?.url,
      method: error.config?.method,
      code: error.code,
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    return Promise.reject(error);
  }
);

export default api;
